import React, {useState} from 'react'
import {
  // Button, ParagraphText,
  Modal,
} from '@thryvlabs/maverick'
import {SchedulerAppointmentComponent} from './scheduler-appointment'
import {SchdulerSuccessComponent} from './scheduler-success'

export const SchedulerViewComponent = ({
  isKickOffCallExist,
  isCreativeCallExist,
  accountInformation,
  showScheduleModal,
  setShowScheduleModalStatus,
  scheduleKickOffCallDetails,
  setScheduledKickOffCallDetails,
  scheduleCreativeCallDetails,
  setScheduledCreativeCallDetails,
  transitionData,
  structuredCart,
  selectedCountry = 'US',
  onSchedulerComplete,
}) => {
  const [isScheduleCompleted, setScheduleCompletedStatus] = useState(false)
  const handleScheduleSuccessStatus = () => setScheduleCompletedStatus(true)
  const handleSkipScheduling = () => {
    // Skip scheduling - close modal and trigger completion callback
    setShowScheduleModalStatus(false)
    setScheduleCompletedStatus(false)
    // Notify parent that scheduling is complete (even though skipped)
    if (onSchedulerComplete) {
      onSchedulerComplete()
    }
  }

  // const BlueGradientBackground = ({
  //   showLogo = true,
  //   backgroundHexColor = '#fff',
  //   width = '100%',
  //   className = '',
  // }) => {
  //   return (
  //     <section
  //       className={`blue-gradient-bg ${className}`}
  //       style={{
  //         background: backgroundHexColor,
  //         width,
  //       }}
  //     >
  //       <div></div>
  //     </section>
  //   )
  // }
  console.log('isKickOffCallExist - schedular ---->', isKickOffCallExist)
  console.log('isCreativeCallExist - schedular ---->', isCreativeCallExist)
  const handleModalClose = () => {
    setShowScheduleModalStatus(false)
    setScheduleCompletedStatus(false)
  }
  return (
    <>
      {showScheduleModal && (
        <Modal
          openOnLoad
          variant="lg"
          onClose={() => setShowScheduleModalStatus(prev => !prev)}
          hideX={isScheduleCompleted}
          width="45%"
        >
          {/* <BlueGradientBackground /> */}
          <div>
            {isScheduleCompleted ? (
              <SchdulerSuccessComponent
                isKickOffCallExist={isKickOffCallExist}
                isCreativeCallExist={isCreativeCallExist}
                scheduleCreativeCallDetails={scheduleCreativeCallDetails}
                scheduleKickOffCallDetails={scheduleKickOffCallDetails}
                accountInformation={accountInformation}
                handleModalClose={handleModalClose}
                structuredCart={structuredCart}
              />
            ) : (
              <SchedulerAppointmentComponent
                isKickOffCallExist={isKickOffCallExist}
                isCreativeCallExist={isCreativeCallExist}
                scheduleCreativeCallDetails={scheduleCreativeCallDetails}
                scheduleKickOffCallDetails={scheduleKickOffCallDetails}
                setScheduledCreativeCallDetails={
                  setScheduledCreativeCallDetails
                }
                setScheduledKickOffCallDetails={setScheduledKickOffCallDetails}
                handleScheduleSuccessStatus={handleScheduleSuccessStatus}
                handleSkipScheduling={handleSkipScheduling}
                accountInformation={accountInformation}
                transitionData={transitionData}
                structuredCart={structuredCart}
                selectedCountry={selectedCountry}
              />
            )}
          </div>
        </Modal>
      )}
    </>
  )
}
